import { Component } from '@angular/core';

@Component({
  selector: 'app-itinerary-explorer-intro',
  templateUrl: './itinerary-explorer-intro.component.html',
  styleUrls: ['./itinerary-explorer-intro.component.css']
})
export class ItineraryExplorerIntroComponent {

}
